var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isEdit && _vm.cooperateEdit,
              expression: "!isEdit && cooperateEdit"
            }
          ],
          staticStyle: { "margin-top": "5px" }
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.export7501(true)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("queryJob.customer")) + "7501")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.export7501()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("queryJob.CustomsClearance")) + "7501")]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "generateCostCharge", type: "primary" },
              on: { click: _vm.generateCostCharge }
            },
            [_vm._v(_vm._s(_vm.$t("queryJob.GenerateReceivableExpense")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "generateSellingCharge", type: "primary" },
              on: { click: _vm.generateSellingCharge }
            },
            [_vm._v(_vm._s(_vm.$t("queryJob.GeneratePayableExpenses")))]
          ),
          (_vm.job.lob === "SE" || _vm.job.lob === "AE") &&
          _vm.readonly &&
          _vm.showSync
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.exportSyncImport }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Synchronization")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-form",
        {
          staticStyle: { margin: "5px 0 10px 0" },
          attrs: { disabled: !_vm.isEdit || !_vm.cooperateEdit }
        },
        [
          _c("div", { staticClass: "flex-row-label" }, [
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DataType")))
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v(_vm._s(_vm.$t("queryJob.MergeProductNamesWhenFiles")))
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v(_vm._s(_vm.$t("queryJob.ShowTax")))
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v(_vm._s(_vm.$t("queryJob.ShowChinaSurtax")))
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v(_vm._s(_vm.$t("queryJob.ShowMargin")))
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.showBond,
                    expression: "form.showBond"
                  }
                ],
                staticClass: "w-180"
              },
              [_vm._v(_vm._s(_vm.$t("queryJob.MarginAmount")))]
            )
          ]),
          _c(
            "div",
            {
              staticClass: "flex-row-content",
              staticStyle: { "line-height": "31px" }
            },
            [
              _c("div", { staticClass: "w-180 mRight-30" }, [
                _vm._v(_vm._s(_vm._f("filterDataType")(_vm.form.dataType)))
              ]),
              _c(
                "div",
                { staticClass: "w-180 mRight-30" },
                [
                  _c("el-switch", {
                    attrs: { no: "generatingFileMergeSameProduct" },
                    on: { change: _vm.toStatistics },
                    model: {
                      value: _vm.form.generatingFileMergeSameProduct,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.form,
                          "generatingFileMergeSameProduct",
                          $$v
                        )
                      },
                      expression: "form.generatingFileMergeSameProduct"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "w-180 mRight-30" },
                [
                  _c("el-switch", {
                    attrs: { no: "showTax" },
                    model: {
                      value: _vm.form.showTax,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "showTax", $$v)
                      },
                      expression: "form.showTax"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "w-180 mRight-30" },
                [
                  _c("el-switch", {
                    attrs: { no: "showChinaSurtax" },
                    model: {
                      value: _vm.form.showChinaSurtax,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "showChinaSurtax", $$v)
                      },
                      expression: "form.showChinaSurtax"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "w-180 mRight-30" },
                [
                  _c("el-switch", {
                    attrs: { no: "showBond" },
                    on: {
                      change: function($event) {
                        _vm.form.bondAmount = _vm.form.showBond
                          ? _vm.form.bondAmount
                          : 0
                      }
                    },
                    model: {
                      value: _vm.form.showBond,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "showBond", $$v)
                      },
                      expression: "form.showBond"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.showBond,
                      expression: "form.showBond"
                    }
                  ],
                  staticClass: "w-180"
                },
                [
                  _c("el-input-number", {
                    attrs: { no: "bondAmount", precision: 2, controls: false },
                    model: {
                      value: _vm.form.bondAmount,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "bondAmount", $$v)
                      },
                      expression: "form.bondAmount"
                    }
                  })
                ],
                1
              )
            ]
          )
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isEdit && _vm.cooperateEdit,
              expression: "isEdit && cooperateEdit"
            }
          ]
        },
        [
          _c(
            "el-button",
            {
              attrs: {
                no: "delete",
                disabled: !_vm.selectedNode,
                type: "danger"
              },
              on: { click: _vm.toDelete }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
          )
        ],
        1
      ),
      _c("cargo-ag-grid", {
        staticStyle: {
          height: "300px",
          "min-height": "300px",
          "margin-top": "5px"
        },
        attrs: {
          "config-module": "130129",
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.rowData
        },
        on: {
          gridReady: function(params) {
            _vm.gridApi = params.api
          }
        }
      }),
      _c(
        "div",
        {
          staticClass: "flex-row-label",
          staticStyle: { "margin-top": "20px" }
        },
        [
          _c("div", { staticClass: "w-180 mRight-30" }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.TotalPacking")))
          ]),
          _c("div", { staticClass: "w-180 mRight-30" }, [
            _vm._v(_vm._s(_vm.$t("queryJob.TotalNetWeight")))
          ]),
          _c("div", { staticClass: "w-180 mRight-30" }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.TotalWeight")))
          ]),
          _c("div", { staticClass: "w-180 mRight-30" }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.TotalCubage")))
          ]),
          _c("div", { staticClass: "w-180 mRight-30" }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.TotalNumberOfPackages")))
          ]),
          _c("div", { staticClass: "w-180" }, [
            _vm._v(_vm._s(_vm.$t("queryJob.TotalValue")))
          ])
        ]
      ),
      _c(
        "div",
        {
          staticClass: "flex-row-content",
          staticStyle: { "line-height": "28px" }
        },
        [
          _c("div", { staticClass: "w-180 mRight-30" }, [
            _vm._v(_vm._s(_vm.form.totalPack))
          ]),
          _c("div", { staticClass: "w-180 mRight-30" }, [
            _vm._v(_vm._s(_vm.form.totalNetWeight))
          ]),
          _c("div", { staticClass: "w-180 mRight-30" }, [
            _vm._v(_vm._s(_vm.form.totalGrossWeight))
          ]),
          _c("div", { staticClass: "w-180 mRight-30" }, [
            _vm._v(_vm._s(_vm.form.totalVolume))
          ]),
          _c("div", { staticClass: "w-180 mRight-30" }, [
            _vm._v(_vm._s(_vm.form.totalNumber))
          ]),
          _c("div", { staticClass: "w-180" }, [
            _vm._v(_vm._s(_vm.form.totalCargoValue.toFixed(4)))
          ])
        ]
      ),
      _c("div", { staticClass: "flex-row-label" }, [
        _c("div", { staticClass: "w-180 mRight-30" }, [
          _vm._v(_vm._s(_vm.$t("queryJob.TotalTariff")))
        ]),
        _c("div", { staticClass: "w-180 mRight-30" }, [
          _vm._v(_vm._s(_vm.$t("queryJob.TotalOtherExpenses")))
        ]),
        _c("div", { staticClass: "w-180" }, [
          _vm._v(_vm._s(_vm.$t("WriteOff.total")))
        ])
      ]),
      _c(
        "div",
        {
          staticClass: "flex-row-content",
          staticStyle: { "line-height": "28px" }
        },
        [
          _c("div", { staticClass: "w-180 mRight-30" }, [
            _vm._v("$" + _vm._s(_vm.form.totalTariff.toFixed(2)))
          ]),
          _c("div", { staticClass: "w-180 mRight-30" }, [
            _vm._v("$" + _vm._s(_vm.form.otherTotalCharge.toFixed(2)))
          ]),
          _c("div", { staticClass: "w-180" }, [
            _vm._v("$" + _vm._s(_vm.form.total.toFixed(2)))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }